var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{staticClass:"modal-large",attrs:{"id":_vm.modalName,"size":"xl","role":"document","title":"Add Truck(s)","ok-disabled":_vm.invalid},on:{"show":_vm.show,"hide":_vm.resetModal,"ok":_vm.submit},model:{value:(_vm.modalIsVisible),callback:function ($$v) {_vm.modalIsVisible=$$v},expression:"modalIsVisible"}})
}
var staticRenderFns = []

export { render, staticRenderFns }